import type { PaddleGetTransactionUrlResponse } from '@vy/api-definition';
import { useQuery } from 'react-query';
import { purge } from '@vy/utils';
import { CustomUseQueryOptions } from '../requests-types/custom-use-query-options';
import { getPrivateApi } from '../../../services/api';
import { queryKeys } from '../../../services/query-key/query-keys';

export function useGetPaddleTransactionUrl(
  vayuInvoiceId: string,
  options?: CustomUseQueryOptions<PaddleGetTransactionUrlResponse>,
) {
  const queryDeps = purge([vayuInvoiceId]);

  return useQuery(
    queryKeys.paddleTransactionUrl(...queryDeps),
    () => {
      const api = getPrivateApi();

      return api.paddleGetTransactionUrl({ vayuInvoiceId });
    },
    {
      ...options,
    },
  );
}
